import React from 'react'
import get from 'lodash/get'
import { MultiselectProps } from './Multiselect.types'
import WithPopup from '../withPopup/withPopup'
import InputWrapper from '../InputWrapper/InputWrapper'
import InputList from '../InputList/InputList'
import useDatasource from '../../useDatasource/useDatasource'
import Icon from '../../Icon/Icon'
import Button from '../../Button/Button'

import useInput from '../useInput'

const InputPlaceholder = ({ placeholder }) => {
    return <div className={'r-input-placeholder'}>{placeholder}</div>
}

const MultiselectDisplayItem = ({ value, data, valueField, textField, onRemove, displayItemTemplate }) => {
    // const valueObject = valueField && typeof?
    const valueObjectIndex = valueField ? data.map((d) => d[valueField]).indexOf(value) : null
    const _value = valueObjectIndex !== null && valueObjectIndex !== -1 ? data[valueObjectIndex] : value

    const text = textField ? get(_value, textField) : _value
    return (
        <div className={'r-multiselect-display-item'}>
            <span className={'r-multiselect-display-item-text'}>
                {displayItemTemplate
                    ? displayItemTemplate({ value, dataItem: _value, data, valueField, textField })
                    : text}
            </span>
            <Button
                style={{ margin: 0, height: '100%' }}
                noRadiusTopLeft
                noRadiusBottomLeft
                className={'r-multiselect-remove-btn'}
                icon={'times'}
                size={'xs'}
                type={'primary'}
                onClick={onRemove}
            />
        </div>
    )
}

const Multiselect: React.FC<MultiselectProps> = (props) => {
    const {
        isDisabled,
        placeholder = 'Select',
        textField,
        valueField,
        allOption = true,
        showPopupOnMount,
        dataItemTemplate,
        displayItemTemplate,
        isListItemDisabledKey,
        isListItemDisabledMessageKey,
    } = props

    // const { data } = useDatasource(dataSource)
    const context = useInput(props, 'array')
    const { data, value, onBlur, onFocus, onChange } = context

    const _value = value || []

    const renderValue = () => {
        if (!value || !Array.isArray(value) || value.length === 0) return <InputPlaceholder placeholder={placeholder} />
        return value.map((v, i) => (
            <MultiselectDisplayItem
                key={i}
                value={v}
                textField={textField}
                valueField={valueField}
                data={data}
                displayItemTemplate={displayItemTemplate}
                onRemove={(e) => {
                    e.stopPropagation()
                    handleChange(getDataItem(v))
                }}
            />
        ))
    }

    const getDataItem = (value) => {
        return data.find((d) => (valueField ? get(d, valueField) === value : d === value))
    }

    const isOptionSelected = (value, option) => {
        return (
            value.find((x) => {
                return x === option
            }) !== undefined
        )
    }

    const handleChange = (dataItem) => {
        const selected = valueField ? get(dataItem, valueField) : dataItem
        let newValue = _value?.slice() ?? []
        if (isOptionSelected(_value, selected)) {
            newValue = newValue.filter((v) => v !== selected)
        } else {
            newValue.push(selected)
        }
        onChange(newValue)
    }

    const handleMassUpdate = (massUpdateValue) => {
        const value = valueField ? massUpdateValue.map((v) => get(v, valueField)) : massUpdateValue
        onChange(value)
    }

    return (
        <InputWrapper {...context}>
            <WithPopup
                showPopupOnMount={showPopupOnMount}
                onShow={() => {
                    onFocus()
                }}
                onClose={() => {
                    onBlur()
                }}
                content={({ openPopup }) => (
                    <InputList
                        dataItemTemplate={dataItemTemplate}
                        setPopupShow={openPopup}
                        data={data}
                        allOption={allOption}
                        handleMassUpdate={handleMassUpdate}
                        value={value}
                        textField={textField}
                        valueField={valueField}
                        onChange={handleChange}
                        isDisabledKey={isListItemDisabledKey}
                        isDisabledMessageKey={isListItemDisabledMessageKey}
                    />
                )}
            >
                {(popupContext) => (
                    <div
                        data-testid='Multiselect'
                        className={'r-multiselect r-input-base'}
                        ref={popupContext.anchor}
                        onClick={(e) => {
                            if (!isDisabled) {
                                popupContext.openPopup()
                            }
                        }}
                    >
                        <div className={'r-input-display-value'}>{renderValue()}</div>
                    </div>
                )}
            </WithPopup>
        </InputWrapper>
    )
}

export default Multiselect
